// extracted by mini-css-extract-plugin
module.exports = {"reasonList":"style_reasonList__kjJzc","reasonItem":"style_reasonItem__6iZmE","svg":"style_svg__XE4LK","text":"style_text__ODxu_"};